/* eslint-disable prettier/prettier */
import React, { useState, useMemo } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/dist/styles.min.css';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import TextField from '@material-ui/core/TextField';
import VehicleMarker from './VehicleMarker';

// 搜尋框組件
const SearchBox = ({ Vehiclelist1, onSearch }) => {
    const searchFields = (searchValue, vehicle) => {
        if (!vehicle) return false;

        const lowerSearchValue = searchValue.toLowerCase();
        return (
            (vehicle.identifier && vehicle.identifier.toLowerCase().includes(lowerSearchValue)) || // 車牌
            (vehicle.eventMessage && vehicle.eventMessage.toLowerCase().includes(lowerSearchValue)) || // 狀態
            (vehicle.FK_UnitID && vehicle.FK_UnitID.toString().includes(lowerSearchValue)) // ID
        );
    };

    return (
        <TextField
            fullWidth
            label="搜尋 (車牌/狀態/ID)"
            onChange={(e) => {
                const searchValue = e.target.value.trim();
                if (searchValue.length > 0 && Array.isArray(Vehiclelist1)) {
                    const found = Vehiclelist1.find((vehicle) => searchFields(searchValue, vehicle));
                    if (found && found.latitude && found.longitude) {
                        onSearch([found.latitude, found.longitude]);
                    }
                }
            }}
            helperText="可搜尋：車牌號碼、車輛狀態、車機ID"
        />
    );
};

// 地圖聚焦控制組件
const MapController = ({ center }) => {
    const map = useMap();
    React.useEffect(() => {
        if (center) {
            map.flyTo(center, 15);
        }
    }, [center, map]);
    return null;
};
const VehicleMap = ({
    centergps,
    setopenmap,
    Vehiclelist1,
    Region,
    OmniEyescar,
    a1a2list,
    outlineColour,
    fillColour,
    transparency,
    icons
}) => {
    const [searchCenter, setSearchCenter] = useState(null);

    const handleSearch = (coords) => {
        setSearchCenter(coords);
    };

    // 記憶化時間格式化函數
    const formatLocalTime = useMemo(
        () => (gpsTime) => {
            if (!gpsTime) return '';
            try {
                const date = new Date(gpsTime);
                date.setHours(date.getHours() + 8);
                return new Intl.DateTimeFormat('zh-TW', {
                    timeZone: 'Asia/Taipei',
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                }).format(date);
            } catch (error) {
                console.error('時間轉換錯誤:', error);
                return gpsTime;
            }
        },
        []
    );

    // 記憶化車輛標記
    const vehicleMarkers = useMemo(
        () =>
            Vehiclelist1.map((incident) => (
                <VehicleMarker
                    key={incident.FK_UnitID}
                    incident={incident}
                    Region={Region}
                    OmniEyescar={OmniEyescar}
                    icons={icons}
                    formatLocalTime={formatLocalTime}
                />
            )),
        [Vehiclelist1, Region, OmniEyescar, icons, formatLocalTime]
    );

    // 記憶化地圖設定
    const mapSettings = useMemo(
        () => ({
            center: centergps,
            zoom: 11,
            zoomControl: false,
            style: { height: '100vh', width: '100%' }
        }),
        [centergps]
    );

    return (
        <>
            <SearchBox Vehiclelist1={Vehiclelist1} onSearch={handleSearch} />
            <MapContainer {...mapSettings} whenCreated={setopenmap}>
                <MapController center={searchCenter} />
                <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <MarkerClusterGroup
                    chunkedLoading
                    maxClusterRadius={60}
                    disableClusteringAtZoom={15}
                    removeOutsideVisibleBounds
                    spiderfyOnMaxZoom
                >
                    {vehicleMarkers}
                </MarkerClusterGroup>
            </MapContainer>
        </>
    );
};

export default VehicleMap;
